import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import DatasetDictionary from '../dictionaries/containers/DatasetDictionary';
import CatalogueTitle from '../catalogue/components/CatalogueTitle';
import DatasetPanelContainer, { mapDispatchToProps, mapStateToProps } from '../components/DatasetPanelContainer';
import DatasetSubscribeAction from '../subscriptions/components/DatasetSubscribeAction';
import DatasetVisibilityLabel from '../components/DatasetVisibilityLabel';
import DatasetCatalogue from '../catalogue/components/DatasetCatalogue';
import DatasetAttachmentsTable from '../attachments/components/DatasetAttachmentsTable';

const NameRow = ({
  code, category, canSubscribe, allowManage, visibility, isNew,
}) => (
  <Grid.Row columns="equal">
    <Grid.Column>
      <CatalogueTitle code={code} category={category} isNew={isNew} />
    </Grid.Column>
    {!isNew && (
      <Grid.Column width={3} floated="right" textAlign="right" className="min-w-230">
        <DatasetVisibilityLabel visibility={visibility} code={code} allowManage={allowManage} />
        {canSubscribe && <DatasetSubscribeAction code={code} category={category} />}
      </Grid.Column>
    )}
  </Grid.Row>
);

const AttachmentsRow = ({ code, category, canReadAttachments }) => (
  <Grid.Row columns="equal" className="h-100p">
    <Grid.Column>
      {canReadAttachments && <DatasetAttachmentsTable code={code} category={category} />}
    </Grid.Column>
  </Grid.Row>
);

const DictionaryRow = ({ category, code }) => (
  <Grid.Row>
    <Grid.Column>
      <DatasetDictionary code={code} category={category} />
    </Grid.Column>
  </Grid.Row>
);

const DatasetPanelFull = ({
  allowManage,
  asViewer,
  canCreate,
  canRead,
  canReadAttachments,
  canSubscribe,
  category,
  code,
  datasetUrl,
  exists,
  fetchData,
  isDirty,
  isNew,
  wizardOn,
  name,
  newDataset,
  onChange,
  readErrors,
  readStatus,
  saveErrors,
  templateReadStatus,
  updateProperties,
  url,
  visibility,
}) => (
  <DatasetPanelContainer
    asViewer={asViewer}
    canCreate={canCreate}
    canRead={canRead}
    category={category}
    className="aridhia-dataset-panel-full panel-wizardible"
    code={code}
    datasetUrl={datasetUrl}
    exists={exists}
    fetchData={fetchData}
    isDirty={isDirty}
    isNew={isNew}
    wizardOn={wizardOn}
    name={name}
    newDataset={newDataset}
    onChange={onChange}
    readErrors={readErrors}
    readStatus={readStatus}
    saveErrors={saveErrors}
    templateReadStatus={templateReadStatus}
    updateProperties={updateProperties}
    url={datasetUrl}
  >
    <Grid>
      <NameRow
        code={code}
        category={category}
        canSubscribe={canSubscribe}
        allowManage={allowManage}
        isNew={isNew}
        visibility={visibility}
      />
      <DatasetCatalogue category={category} code={code} url={url} isNew={isNew} />
      {canReadAttachments && (
        <AttachmentsRow code={code} category={category} canReadAttachments={canReadAttachments} />
      )}
      <DictionaryRow code={code} category={category} />
    </Grid>
  </DatasetPanelContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(DatasetPanelFull);
